import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageService } from '../../../shared/services/language.service';
import { AdminRoleService } from '../../../_api/services/role.service';
import { AmsNotifierService } from '../../../shared/services/ams-notifier.service';

@Component({
  selector: 'app-reset-time',
  templateUrl: './reset-time.component.html',
  styleUrls: ['./reset-time.component.css']
})
export class ResetTimeComponent implements OnInit {

  selectedStatusId: number;
  approvalLevelRecords: any[];
  approvalLevelStatuses: any;
  approvalLevelStatusesToSelect: any;
  roles: any;
  categories: any;
  statuses: any;
  placeholderStatusSelect = this.ls.LNG("Label.Select.Reset.Status");

  @Input() selectedStatusIds = [];

  @Output() loading = new EventEmitter<boolean>();
  @Output() reset = new EventEmitter<number>();
  @Output() resetCancelled = new EventEmitter<void>();

  constructor(public ls: LanguageService,
    private _adminRoleService: AdminRoleService,
    private _amsNotifierService: AmsNotifierService) { }

  ngOnInit(): void {
    this.createColumns();
    this.loading.emit(true);
    this.loadAvailableStatuses();
    this.loadCategories();
    this.loadRoles();
    this.loadStatuses();
    this.loadApprovalLevels();
    this.loading.emit(false);
  }

  ngOnChanges() {
    
    this.setAvailableStatusesToSelect();
  }

  createColumns() {
  }

  async loadApprovalLevels() {
    
    let approvalLevels = await this._adminRoleService.getAvailableApprovalLevels().toPromise();
    this.approvalLevelRecords = approvalLevels.filter(rec => {
      return rec.ApprovalType == 2
    });
    
  }

  async loadRoles() {
    this.roles = await this._adminRoleService.getRoles().toPromise();
  }

  async loadCategories() {
    this.categories = await this._adminRoleService.getCategories().toPromise();
  }

  async loadStatuses() {
    this.statuses = await this._adminRoleService.getStatuses().toPromise();
  }

  async loadAvailableStatuses() {
    this.approvalLevelStatuses = await this._adminRoleService.getAvailableApprovalLevelStatuses().toPromise();
    
    this.setAvailableStatusesToSelect();
  }

  setAvailableStatusesToSelect() {
    this.approvalLevelStatusesToSelect = [];
    if (this.approvalLevelStatuses) {
      this.approvalLevelStatuses.forEach(status => {
        
        if (this.selectedStatusIds.some(s => s > status.StatusId)) {
          this.approvalLevelStatusesToSelect.push(status);
        }
      });
      if (this.approvalLevelStatusesToSelect.length == 0) {
        this.placeholderStatusSelect = this.ls.LNG("Label.No.Selectable.Statuses.For.Selected.Time.Posts");
      }
      else {
        this.placeholderStatusSelect = this.ls.LNG("Label.Select.Reset.Status");
      }
    }
  }

  onReset() {
    
    if (!this.selectedStatusId) {
      this._amsNotifierService.error(this.ls.LNG("Label.Please.Select.A.Status"));
      return;
    }
    this.reset.emit(this.selectedStatusId);
  }

  onResetCancelled() {
    this.resetCancelled.emit();
  }

}
